<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import { TrashIcon, PlusIcon, InformationCircleIcon } from '@heroicons/vue/24/outline'
import { ChatBubbleLeftEllipsisIcon, TagIcon, UserCircleIcon, BriefcaseIcon, AcademicCapIcon, PresentationChartLineIcon } from '@heroicons/vue/20/solid'

import moment from 'moment/dist/moment';

const graduationTypes = ['Ausgeübter Beruf', 'Berufsausbildung', 'Studium', 'Qualifikation', 'Schulabschluss', 'Weiterbildung', 'BFD/FSJ'];

const props = defineProps(['graduations']);

const compareGraduations = (b, a) => {
    const endA = a.active ? moment().add(1, 'days') : (a.end ? moment(a.end, 'YYYY-MM') : moment(a.start, 'YYYY-MM'));
    const endB = b.active ? moment().add(1, 'days') : (b.end ? moment(b.end, 'YYYY-MM') : moment(b.start, 'YYYY-MM'));

    if (endA.isBefore(endB)) return -1;
    if (endA.isAfter(endB)) return 1;

    return 0;
};

const graduations = ref(JSON.parse(props.graduations).sort(compareGraduations));
</script>

<template>
    <div class="tw-flow-root">
        <ul role="list" class="-tw-mb-8 tw-pl-0 tw-list-none">
            <li v-for="(graduation, index) in graduations" :key="index">
                <div class="tw-relative tw-pb-8">
                    <span v-if="index !== graduations.length - 1"
                        class="tw-absolute tw-left-5 tw-top-5 tw--ml-px tw-h-full tw-w-0.5 tw-bg-gray-200"
                        aria-hidden="true" />
                    <div class="tw-relative tw-flex tw-items-start tw-space-x-3">

                        <div>
                            <div class="tw-relative tw-px-1">
                                <div
                                    class="tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-full tw-bg-gray-100 tw-ring-8 tw-ring-white">
                                    <BriefcaseIcon v-if="graduation.type < 2 || graduation.type == 6"
                                        class="tw-h-5 tw-w-5 tw-text-gray-500" aria-hidden="true" />
                                    <AcademicCapIcon v-else-if="graduation.type == 2 || graduation.type == 4"
                                        class="tw-h-5 tw-w-5 tw-text-gray-500" aria-hidden="true" />
                                    <PresentationChartLineIcon v-else-if="graduation.type == 3 || graduation.type == 5"
                                        class="tw-h-5 tw-w-5 tw-text-gray-500" aria-hidden="true" />
                                </div>
                            </div>
                        </div>
                        <div class="tw-min-w-0 tw-flex-1">
                            <div>
                                <div class="tw-text-sm">
                                    <span class="tw-font-medium tw-text-gray-900">{{ graduationTypes[graduation.type]
                                        }}</span>
                                </div>
                                <p class="tw-mt-0.5 tw-mb-0 tw-text-sm tw-text-gray-500">
                                    {{ moment(graduation.start).format('MMM YYYY') }}
                                    {{ graduation.active ? ' - Heute' :
                graduation.end ? ' - ' + moment(graduation.end).format('MMM YYYY') : '' }}
                                </p>
                            </div>
                            <div class="tw-mt-2 tw-text-sm tw-text-gray-700">
                                <p class="tw-mb-0">{{ graduation.description }}</p>
                            </div>
                        </div>

                    </div>
                </div>
            </li>
        </ul>
    </div>
</template>
